import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Modal extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    close: PropTypes.func,
    footer: PropTypes.node,
    open: PropTypes.bool,
    size: PropTypes.oneOf(['lg', 'md', 'sm', 'xl']),
    title: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.toggle();
    $(this.ref.current).on('hidden.bs.modal', this.props.close);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.toggle();
    }
  }

  close() {
    $(this.ref.current).modal('hide');
  }

  open() {
    $(this.ref.current).modal('show');
  }

  render() {
    return (
      <div className="fade modal" ref={this.ref}>
        <div className={`modal-dialog modal-${this.props.size}`}>
          <div className="modal-content">
            <div className="modal-header">
              {this.props.title && (
                <h5 className="modal-title">{this.props.title}</h5>
              )}
              <button
                className="close"
                onClick={() => this.props.close()}
                type="button"
              >
                &times;
              </button>
            </div>
            {this.props.children && (
              <div className="modal-body">{this.props.children}</div>
            )}
            {this.props.footer && (
              <div className="modal-footer">{this.props.footer}</div>
            )}
          </div>
        </div>
      </div>
    );
  }

  toggle() {
    this.props.open ? this.open() : this.close();
  }
}
